import PropTypes from "prop-types";
import React from "react";
import { getProductCatUrl } from "../../helpers/url";

const ImageSliderOneSingle = ({ data, sliderClass }) => {

  return (
    <div id="antera-image-slider-container collection-product" className={`collection-product ${sliderClass ? sliderClass : ""}`}>
      <div className="collection-img">
        <a href={getProductCatUrl(data.link)}>
          <img src={process.env.PUBLIC_URL + data.image} alt="" className="antera-image-slider-image" />
        </a>
      </div>
    </div>
  );
};

ImageSliderOneSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string,
};

export default ImageSliderOneSingle;
